var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup1017(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Group_1017",
    "data-name": "Group 1017",
    width: 653.275,
    height: 587.562,
    viewBox: "0 0 653.275 587.562",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_280",
    "data-name": "Rectangle 280",
    width: 653.275,
    height: 587.562,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    width: 653.275,
    height: 570.568,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_231",
    "data-name": "Rectangle 231",
    width: 258.519,
    height: 533.124,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 129.824,
    height: 40.452,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_233",
    "data-name": "Rectangle 233",
    width: 129.824,
    height: 40.451,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    width: 275.222,
    height: 391.213,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    width: 19.39,
    height: 19.39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    width: 19.39,
    height: 19.389,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_947",
    "data-name": "Group 947",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    "data-name": "Group 946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_945",
    "data-name": "Group 945",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M634.144,350.2c-20.7,54-62.992,112.439-122.508,129.743-89.925,26.152-100.668,96.75-261.734,90.2a333.085,333.085,0,0,1-69.647-9.947,275.646,275.646,0,0,1-32.745-10.609C53.415,512.466,4.33,430.769.256,345.287-5.122,232.861,75.417,179.273,127.761,147.9S243.193-5.063,401.583.163a322.751,322.751,0,0,1,71.589,10.185C526.468,24.4,580.645,55.47,612.128,100.9q3.545,5.118,6.778,10.463c42.13,69.62,43.462,165.221,15.239,238.836",
    transform: "translate(0 0)",
    fill: "#ff6d0c"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M519.9,173.142s-22.851-12.694-24.543,16.081-5.924,308.191-5.924,308.191",
    transform: "translate(43.88 15.273)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M483.977,190s18.637,133.853,10.174,303.118",
    transform: "translate(43.391 17.034)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M506.268,180.342s-8.74,5.6-13.714-.81,3.365-18.15-3.985-23.171S468.535,159,468.535,159s9.77,2.87,9.455,8.2-5.021,7.35-5.648,5.019-5.286-14.074-13.22-9.19a19.647,19.647,0,0,0-9.145,12.458s18.465-1.969,19.584,4.979-7.574-1.212-15.193-1.662-14.567.67-14.074,5.286-.719,12.191-.719,12.191,6.455-5.736,14.836-5.241,8.067,5.829.448,5.379-14.164,6.81-14.164,6.81,6.945,11.878,15.774,17.75,12.01,3.767,13.042-.759S468.169,204.09,473.5,204.4s-8.833,20.123-2.02,21.29,12.28-.805,14.074-5.287l1.794-4.482s-2.373-11.608-1.341-16.135,2.285.135,3.495,5.558,1.969,18.465,4.3,17.839,9.772-10.128,11.521-13.847-9.813-15.106-9.678-17.392,9.053,2.064,10.442,4.439a59.092,59.092,0,0,1,2.733,5.514s5.558-3.5,5.425-14.207-7.976-7.352-7.976-7.352",
    transform: "translate(39.41 13.866)",
    fill: "#5ae4a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M506.268,180.342s-8.74,5.6-13.714-.81,3.365-18.15-3.985-23.171S468.535,159,468.535,159s9.77,2.87,9.455,8.2-5.021,7.35-5.648,5.019-5.286-14.074-13.22-9.19a19.647,19.647,0,0,0-9.145,12.458s18.465-1.969,19.584,4.979-7.574-1.212-15.193-1.662-14.567.67-14.074,5.286-.719,12.191-.719,12.191,6.455-5.736,14.836-5.241,8.067,5.829.448,5.379-14.164,6.81-14.164,6.81,6.945,11.878,15.774,17.75,12.01,3.767,13.042-.759S468.169,204.09,473.5,204.4s-8.833,20.123-2.02,21.29,12.28-.805,14.074-5.287l1.794-4.482s-2.373-11.608-1.341-16.135,2.285.135,3.495,5.558,1.969,18.465,4.3,17.839,9.772-10.128,11.521-13.847-9.813-15.106-9.678-17.392,9.053,2.064,10.442,4.439a59.092,59.092,0,0,1,2.733,5.514s5.558-3.5,5.425-14.207-7.976-7.352-7.976-7.352",
    transform: "translate(39.41 13.866)",
    fill: "#bc4002"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M460.114,203.018c5.7-7.047,14.1-16.581,21.14-21.132",
    transform: "translate(41.251 16.307)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M454.05,209.57s1.463-2.034,3.836-5.084",
    transform: "translate(40.708 18.333)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M482.929,183.491s8.469,11.969,10.036,24.294",
    transform: "translate(43.297 16.451)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M474.126,189.991s2.375-1.389,1.476,13.85",
    transform: "translate(42.507 17.031)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M479.8,178.049s4.841-4.3,2.288-12.863",
    transform: "translate(43.016 14.81)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x1: 3.45,
    y1: 6.32,
    transform: "translate(512.826 193.799)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M468.6,190.291s-10.979-8.293-17.837-8.7",
    transform: "translate(40.413 16.281)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M533.444,157.961s-.35,12.569-10.158,13.179-15.881-15.74-25.916-11.8-11.012,21.858-11.012,21.858,9.533-7.826,14.658-3.875,3.936,10.037,1.176,9.076-17.695-4.3-18.213,6.972a23.8,23.8,0,0,0,6.239,17.648s10.615-19.831,18.333-16.215-6.376,6.757-12.019,14.079-9.258,15.041-4.3,17.694,11.715,9.03,11.715,9.03-1.344-10.372,4.864-18.426,11.333-4.1,5.69,3.218-2.836,18.823-2.836,18.823,16.626,1.143,28.524-3.693,11.959-9.458,8.13-13.576-17.069-9.654-13.119-14.78,14.126,22.559,19.937,16.533,7.565-12.843,4.3-17.694l-3.265-4.85s-13.24-5.537-17.069-9.655,1.693-2.2,7.947.29,19.831,10.615,20.792,7.854-3.479-16.687-6.012-20.974-21.813-.471-24.008-2.164,8.236-7.658,11.561-7.429a71.723,71.723,0,0,1,7.382,1.022s.29-7.948-10.525-15.116-12.8,2.975-12.8,2.975",
    transform: "translate(43.388 13.665)",
    fill: "#5ae4a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M533.444,157.961s-.35,12.569-10.158,13.179-15.881-15.74-25.916-11.8-11.012,21.858-11.012,21.858,9.533-7.826,14.658-3.875,3.936,10.037,1.176,9.076-17.695-4.3-18.213,6.972a23.8,23.8,0,0,0,6.239,17.648s10.615-19.831,18.333-16.215-6.376,6.757-12.019,14.079-9.258,15.041-4.3,17.694,11.715,9.03,11.715,9.03-1.344-10.372,4.864-18.426,11.333-4.1,5.69,3.218-2.836,18.823-2.836,18.823,16.626,1.143,28.524-3.693,11.959-9.458,8.13-13.576-17.069-9.654-13.119-14.78,14.126,22.559,19.937,16.533,7.565-12.843,4.3-17.694l-3.265-4.85s-13.24-5.537-17.069-9.655,1.693-2.2,7.947.29,19.831,10.615,20.792,7.854-3.479-16.687-6.012-20.974-21.813-.471-24.008-2.164,8.236-7.658,11.561-7.429a71.723,71.723,0,0,1,7.382,1.022s.29-7.948-10.525-15.116-12.8,2.975-12.8,2.975",
    transform: "translate(43.388 13.665)",
    fill: "#d14f07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M525.287,216.859c-3.17-10.51-6.99-25.419-6.748-35.57",
    transform: "translate(46.488 16.253)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M528.684,225.971s-1.039-2.853-2.476-7.306",
    transform: "translate(47.177 19.604)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M522.472,178.965s17.755-.321,31.163,6.512",
    transform: "translate(46.842 16.045)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M522.977,192.246s.228-3.326,14.872,7.962",
    transform: "translate(46.887 17.195)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M514.766,178.574s-1.007-7.779-11.318-11.058",
    transform: "translate(45.136 15.019)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x1: 8.679,
    y1: 0.854,
    transform: "translate(554.03 204.239)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M519.514,198.927s-15.787,5.339-20.866,11.93",
    transform: "translate(44.706 17.835)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M432.733,234.272s54.653,44.395,49.087,253.181",
    transform: "translate(38.796 21.003)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M494.225,226.751S492.634,241.222,481.259,241s-16.838-19.663-28.791-16.068-14.77,24.184-14.77,24.184,11.739-8.13,17.281-3.088,3.594,11.953.5,10.584-20.012-6.633-21.673,6.327a27.556,27.556,0,0,0,5.534,20.953s14.121-21.88,22.686-16.981-7.995,7.2-15.2,15.112-12.1,16.482-6.633,20.012S452.86,313.56,452.86,313.56s-.571-12.1,7.353-20.8,13.465-3.666,6.261,4.251-5.049,21.453-5.049,21.453,19.078,2.888,33.263-1.569,14.692-9.785,10.662-14.9-18.785-12.751-13.743-18.293,14.171,27.364,21.445,20.961,9.942-14.107,6.633-20.012l-3.309-5.906s-14.756-7.638-18.786-12.751,2.161-2.375,9.143,1.084,21.88,14.121,23.25,11.025-2.44-19.583-4.957-24.769-25.125-2.6-27.5-4.764,10.227-8.059,14.044-7.48a83.083,83.083,0,0,1,8.422,1.875s1.084-9.143-10.719-18.436-15.048,2.225-15.048,2.225",
    transform: "translate(38.87 19.805)",
    fill: "#5ae4a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M494.225,226.751S492.634,241.222,481.259,241s-16.838-19.663-28.791-16.068-14.77,24.184-14.77,24.184,11.739-8.13,17.281-3.088,3.594,11.953.5,10.584-20.012-6.633-21.673,6.327a27.556,27.556,0,0,0,5.534,20.953s14.121-21.88,22.686-16.981-7.995,7.2-15.2,15.112-12.1,16.482-6.633,20.012S452.86,313.56,452.86,313.56s-.571-12.1,7.353-20.8,13.465-3.666,6.261,4.251-5.049,21.453-5.049,21.453,19.078,2.888,33.263-1.569,14.692-9.785,10.662-14.9-18.785-12.751-13.743-18.293,14.171,27.364,21.445,20.961,9.942-14.107,6.633-20.012l-3.309-5.906s-14.756-7.638-18.786-12.751,2.161-2.375,9.143,1.084,21.88,14.121,23.25,11.025-2.44-19.583-4.957-24.769-25.125-2.6-27.5-4.764,10.227-8.059,14.044-7.48a83.083,83.083,0,0,1,8.422,1.875s1.084-9.143-10.719-18.436-15.048,2.225-15.048,2.225",
    transform: "translate(38.87 19.805)",
    fill: "#bc4002"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M478.94,294.373c-2.666-12.426-5.667-29.991-4.429-41.68",
    transform: "translate(42.516 22.655)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M481.976,305.209s-.931-3.39-2.167-8.664",
    transform: "translate(43.017 26.587)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M479.245,250.382s20.518,1.305,35.345,10.455",
    transform: "translate(42.966 22.448)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M478.578,265.748s.578-3.816,16.41,10.59",
    transform: "translate(42.907 23.784)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M470.39,249.2s-.428-9.071-12.017-13.829",
    transform: "translate(41.095 21.102)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x1: 9.934,
    y1: 1.804,
    transform: "translate(503.705 282.037)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M474.041,272.975s-18.721,4.671-25.2,11.8",
    transform: "translate(40.24 24.473)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M494.225,356.129s-1.591,14.471-12.966,14.249-16.838-19.663-28.791-16.068-14.77,24.184-14.77,24.184,11.739-8.13,17.281-3.088,3.594,11.953.5,10.584-20.012-6.633-21.673,6.327a27.556,27.556,0,0,0,5.534,20.953s14.121-21.88,22.686-16.981-7.995,7.2-15.2,15.112-12.1,16.482-6.633,20.011,12.666,11.525,12.666,11.525-.571-12.1,7.353-20.8,13.465-3.666,6.261,4.251-5.049,21.453-5.049,21.453,19.078,2.888,33.263-1.569,14.692-9.785,10.662-14.9-18.785-12.751-13.743-18.293,14.171,27.365,21.445,20.961,9.942-14.107,6.633-20.013l-3.309-5.9s-14.756-7.638-18.786-12.751,2.161-2.375,9.143,1.084,21.88,14.121,23.25,11.025-2.44-19.584-4.957-24.769-25.125-2.6-27.5-4.764,10.227-8.059,14.044-7.482a83.278,83.278,0,0,1,8.422,1.876s1.084-9.143-10.719-18.436-15.048,2.225-15.048,2.225",
    transform: "translate(38.87 31.404)",
    fill: "#5ae4a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M494.225,356.129s-1.591,14.471-12.966,14.249-16.838-19.663-28.791-16.068-14.77,24.184-14.77,24.184,11.739-8.13,17.281-3.088,3.594,11.953.5,10.584-20.012-6.633-21.673,6.327a27.556,27.556,0,0,0,5.534,20.953s14.121-21.88,22.686-16.981-7.995,7.2-15.2,15.112-12.1,16.482-6.633,20.011,12.666,11.525,12.666,11.525-.571-12.1,7.353-20.8,13.465-3.666,6.261,4.251-5.049,21.453-5.049,21.453,19.078,2.888,33.263-1.569,14.692-9.785,10.662-14.9-18.785-12.751-13.743-18.293,14.171,27.365,21.445,20.961,9.942-14.107,6.633-20.013l-3.309-5.9s-14.756-7.638-18.786-12.751,2.161-2.375,9.143,1.084,21.88,14.121,23.25,11.025-2.44-19.584-4.957-24.769-25.125-2.6-27.5-4.764,10.227-8.059,14.044-7.482a83.278,83.278,0,0,1,8.422,1.876s1.084-9.143-10.719-18.436-15.048,2.225-15.048,2.225",
    transform: "translate(38.87 31.404)",
    fill: "#bc4002"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M478.94,423.752c-2.666-12.426-5.667-29.992-4.429-41.681",
    transform: "translate(42.516 34.254)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M481.976,434.587s-.931-3.39-2.167-8.664",
    transform: "translate(43.017 38.186)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M479.245,379.76s20.518,1.305,35.345,10.455",
    transform: "translate(42.966 34.047)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M478.578,395.126s.578-3.816,16.41,10.59",
    transform: "translate(42.907 35.384)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M470.39,378.581s-.428-9.071-12.017-13.829",
    transform: "translate(41.095 32.702)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x1: 9.934,
    y1: 1.804,
    transform: "translate(503.705 423.014)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M474.041,402.354s-18.721,4.671-25.2,11.8",
    transform: "translate(40.24 36.073)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M450.6,331.712s32.16,116.924,35.546,153.315L479.37,270.776",
    transform: "translate(40.398 24.276)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M525.534,310.408C483.217,302.791,483.217,481.5,483.217,481.5",
    transform: "translate(43.322 27.808)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M488.215,488.917S463.67,217.962,534.762,217.962",
    transform: "translate(43.403 19.541)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M509.615,307.54c-5.781-6.5-18.063-6.5-25.289,10.115s-.722,13.729-.722,13.729,13.727-4.336,22.4-7.225,20.232-10.115,20.954-5.781-5.781,8.67-13.729,10.115-28.9,7.225-26.734,11.56,7.225,17.342,7.225,17.342a183.972,183.972,0,0,1,19.508-14.451c9.393-5.781,15.173-3.612,10.115,2.89s-19.508,13.729-16.617,22.4,20.231,19.508,20.231,19.508,2.167-18.063,7.225-23.844,5.057.722,3.612,10.839-1.445,13.005-1.445,13.005l20.23,7.226s7.225-10.839,10.839-14.451l3.612-3.612s-15.9-13.729-16.618-22.4,10.838,0,14.451,1.445,9.393,11.561,9.393,11.561,3.612-16.618,4.335-22.4l.722-5.78s-15.172-5.781-20.953-5.781-8.67,4.335-8.67-1.445,5.781-9.393,12.283-8.67,17.341,4.335,17.341,4.335,4.336-3.612,2.89-14.451-5.057-10.838-13.727-7.947-14.451,9.393-20.953,9.393-2.891-7.948,1.445-10.115,15.173-6.5,17.341-7.225-11.56-10.838-18.786-12.284-16.581,3.646-15.9,10.838c1.445,15.173-20.231,18.064-26.011,11.561",
    transform: "translate(43.116 25.542)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M549.939,373.95q.324,3.264.453,6.529",
    transform: "translate(49.304 33.526)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M536.618,326.348c5.073,11.727,10.942,27.9,13.6,44.772",
    transform: "translate(48.11 29.259)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M534.746,323.471c-3.58-7.7-6.273-12.389-6.273-12.389s6.5-2.89,9.393-8.67a24.058,24.058,0,0,1,7.225-8.67",
    transform: "translate(47.38 26.335)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M505.265,332.937s26.011-10.838,26.011-8.67",
    transform: "translate(45.299 29.046)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M542.4,320.077s11.56-5.781,21.675-5.781",
    transform: "translate(48.628 28.178)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M540.381,335.515a100.034,100.034,0,0,0-13.727,13.729,62.259,62.259,0,0,0-10.116,16.617",
    transform: "translate(46.31 30.08)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M545.713,338.274s15.173-4.336,23.121,2.89",
    transform: "translate(48.926 30.212)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M578.6,253.52c-7.867-4.653-16.567-4.754-20.83-9.665s4.107-7.392,8.586-5.54,14.857,7.195,16.823,8.358.606-15.835-3.04-22.238-13.622-10.132-18.6-4.9c-10.51,11.038-26.9-3.435-25.781-12.062s-6.931-17.9-24.216-12.466-10.841,8.455-10.841,8.455,12.274,7.524,20.14,12.177,20.9,8.646,18.1,12.033-10.336,1.32-16.638-3.735-24.4-17.087-26.256-12.608-8.358,16.824-8.358,16.824a184.022,184.022,0,0,1,23.7,5.258c10.523,3.3,12.675,9.09,4.449,9.533s-23.155-5.732-27.808,2.135-1.469,28.066-1.469,28.066,15.061-10.2,22.742-10.175,2.77,4.293-5.817,9.833-10.768,7.435-10.768,7.435l7.806,20.014s12.921-1.649,18.017-1.289l5.1.36s-.053-21,6.019-27.233,7.106,8.184,8.383,11.86-2.572,14.672-2.572,14.672,14.917-8.167,19.755-11.411l4.838-3.244s-5.582-15.246-9.371-19.612-8.958-3.7-4.593-7.495,10.882-1.792,14.6,3.592,8.1,15.936,8.1,15.936,5.57.905,12.807-7.291,4.869-10.924-3-15.577m-68.379,23.127c-5.78-2.89,7.948-8.67,7.948-8.67,5.058-.722-2.167,11.561-7.948,8.67m9.734-26.974c-2.464-1.231,4.928-3.7,4.928-3.7,10.677,2.054-2.465,4.928-4.928,3.7",
    transform: "translate(43.526 17.338)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M508.424,283.3q-2.252,2.383-4.633,4.622",
    transform: "translate(45.167 25.399)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M537.3,242.039c-5.529,11.52-13.893,26.552-24.893,39.621",
    transform: "translate(45.94 21.7)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M537.709,237.8c3.466-7.749,5.243-12.859,5.243-12.859s6.445,3.015,12.705,1.408a24.074,24.074,0,0,1,11.283-.228",
    transform: "translate(48.208 20.167)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M510.283,222.2s25.236,12.536,23.6,13.957",
    transform: "translate(45.749 19.921)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M544.139,241.98s11.944,4.94,18.574,12.579",
    transform: "translate(48.784 21.695)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M532.685,249.523a99.992,99.992,0,0,0-19.366-1.366,62.257,62.257,0,0,0-19.18,3.255",
    transform: "translate(44.302 22.246)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M532.292,256.655s13.221,8.616,12.974,19.354",
    transform: "translate(47.722 23.01)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M474.065,344.433c-6.33-3.745-13.332-3.827-16.762-7.778s3.3-5.95,6.91-4.459,11.957,5.79,13.539,6.726.487-12.743-2.446-17.9-10.963-8.153-14.972-3.942c-8.458,8.883-21.65-2.764-20.748-9.708s-5.578-14.407-19.488-10.031-8.724,6.8-8.724,6.8,9.878,6.055,16.208,9.8,16.82,6.957,14.568,9.684-8.318,1.061-13.39-3.005-19.639-13.751-21.13-10.147-6.726,13.539-6.726,13.539a147.986,147.986,0,0,1,19.074,4.231c8.468,2.659,10.2,7.315,3.58,7.672s-18.634-4.612-22.378,1.717S400,360.225,400,360.225s12.12-8.213,18.3-8.188,2.228,3.454-4.68,7.913a94.757,94.757,0,0,0-8.666,5.982l6.282,16.106s10.4-1.327,14.5-1.037l4.1.29s-.044-16.9,4.845-21.916,5.717,6.587,6.745,9.544-2.069,11.807-2.069,11.807,12-6.573,15.9-9.183l3.894-2.611s-4.493-12.27-7.542-15.783-7.209-2.981-3.7-6.031,8.758-1.443,11.749,2.89,6.514,12.825,6.514,12.825,4.483.729,10.306-5.867,3.918-8.791-2.413-12.535m-55.028,18.611c-4.651-2.326,6.4-6.978,6.4-6.978,4.071-.581-1.745,9.3-6.4,6.978m7.834-21.708c-1.983-.992,3.966-2.974,3.966-2.974,8.592,1.652-1.983,3.965-3.966,2.974",
    transform: "translate(35.785 26.541)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M417.594,368.4q-1.813,1.919-3.729,3.72",
    transform: "translate(37.105 33.029)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M440.834,335.193c-4.45,9.27-11.18,21.367-20.032,31.885",
    transform: "translate(37.727 30.051)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M441.161,331.785c2.789-6.236,4.219-10.348,4.219-10.348s5.188,2.427,10.225,1.134a19.366,19.366,0,0,1,9.08-.184",
    transform: "translate(39.552 28.818)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M419.09,319.227s20.309,10.089,18.992,11.232",
    transform: "translate(37.573 28.62)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M446.335,335.146s9.612,3.976,14.948,10.123",
    transform: "translate(40.016 30.047)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M437.118,341.216a80.486,80.486,0,0,0-15.585-1.1,50.089,50.089,0,0,0-15.435,2.62",
    transform: "translate(36.408 30.491)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M436.8,346.955s10.639,6.933,10.441,15.576",
    transform: "translate(39.161 31.106)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M530.27,416.014c-6.33-3.744-13.332-3.826-16.762-7.778s3.3-5.948,6.909-4.458,11.957,5.79,13.539,6.726.487-12.743-2.446-17.9-10.962-8.153-14.972-3.942c-8.459,8.884-21.65-2.764-20.748-9.708s-5.578-14.407-19.488-10.031-8.724,6.8-8.724,6.8,9.878,6.055,16.208,9.8,16.82,6.957,14.566,9.684-8.318,1.061-13.389-3.005-19.639-13.751-21.129-10.147-6.726,13.539-6.726,13.539a147.981,147.981,0,0,1,19.074,4.231c8.468,2.659,10.2,7.315,3.58,7.672s-18.634-4.612-22.378,1.717-1.182,22.586-1.182,22.586,12.12-8.213,18.3-8.189,2.229,3.455-4.681,7.914a94.554,94.554,0,0,0-8.665,5.982l6.282,16.106s10.4-1.327,14.5-1.037l4.1.29s-.044-16.9,4.845-21.916,5.717,6.587,6.746,9.544-2.07,11.806-2.07,11.806,12-6.572,15.9-9.181l3.894-2.611s-4.493-12.27-7.543-15.783-7.208-2.982-3.7-6.031,8.758-1.443,11.749,2.89,6.514,12.825,6.514,12.825,4.483.729,10.306-5.867,3.918-8.791-2.412-12.536m-55.028,18.612c-4.651-2.326,6.4-6.978,6.4-6.978,4.071-.581-1.745,9.3-6.4,6.978m7.834-21.708c-1.983-.992,3.966-2.975,3.966-2.975,8.592,1.653-1.983,3.966-3.966,2.975",
    transform: "translate(40.824 32.959)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M473.8,439.983q-1.813,1.919-3.729,3.72",
    transform: "translate(42.144 39.446)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M497.04,406.775c-4.45,9.271-11.18,21.367-20.032,31.885",
    transform: "translate(42.766 36.469)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M497.366,403.367c2.789-6.236,4.219-10.348,4.219-10.348s5.187,2.427,10.224,1.133a19.379,19.379,0,0,1,9.081-.183",
    transform: "translate(44.591 35.236)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M475.3,390.809S495.6,400.9,494.287,402.042",
    transform: "translate(42.612 35.038)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M502.541,406.728s9.612,3.976,14.948,10.123",
    transform: "translate(45.055 36.465)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M493.323,412.8a80.52,80.52,0,0,0-15.584-1.1,50.108,50.108,0,0,0-15.436,2.621",
    transform: "translate(41.447 36.909)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M493.007,418.538s10.639,6.933,10.441,15.576",
    transform: "translate(44.2 37.524)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M449.328,232.845s-7.948,5.781-13.005,0,2.167-17.341-5.058-21.675-18.786,3.612-18.786,3.612,9.393,2.167,9.393,7.225-4.336,7.225-5.058,5.057-5.78-13.005-13.005-7.948a18.6,18.6,0,0,0-7.948,12.284s17.341-2.891,18.786,3.612-7.225-.722-14.451-.722-13.727,1.445-13.005,5.781,0,11.56,0,11.56,5.781-5.781,13.729-5.781,7.947,5.058.722,5.058-13.006,7.225-13.006,7.225,7.225,10.838,15.9,15.9,11.56,2.89,12.283-1.446-2.167-15.172,2.891-15.172-7.225,19.508-.722,20.231,11.56-1.445,13.005-5.781l1.445-4.335s-2.89-10.838-2.167-15.173,2.167,0,3.612,5.058,2.891,17.341,5.058,16.618,8.67-10.115,10.115-13.729-10.115-13.729-10.115-15.9,8.67,1.445,10.115,3.613a56.078,56.078,0,0,1,2.89,5.057s5.058-3.612,4.336-13.727-7.948-6.5-7.948-6.5",
    transform: "translate(34.708 18.816)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M407.066,256.745c4.994-6.977,12.4-16.456,18.8-21.149",
    transform: "translate(36.495 21.122)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M401.774,263.2s1.269-2,3.342-5.019",
    transform: "translate(36.021 23.147)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M427.634,236.923s8.67,10.838,10.838,22.4",
    transform: "translate(38.339 21.241)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M419.677,243.556s2.167-1.445,2.167,13.005",
    transform: "translate(37.626 21.832)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M424.319,231.966s4.335-4.336,1.445-12.284",
    transform: "translate(38.042 19.695)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x1: 3.612,
    y1: 5.78,
    transform: "translate(452.968 253.107)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M414.473,244.148s-10.838-7.225-17.341-7.225",
    transform: "translate(35.605 21.241)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    width: 55.858,
    height: 80.401,
    transform: "translate(501.149 506.616)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 55.858,
    height: 80.401,
    transform: "translate(501.149 506.616)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x2: 138.32,
    transform: "translate(510.667 587.017)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x2: 488.518,
    transform: "translate(16.635 587.017)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M404.131,583.977H191.779a31.311,31.311,0,0,1-31.31-31.31V65.219a31.31,31.31,0,0,1,31.31-31.31H404.131a31.31,31.31,0,0,1,31.31,31.31V552.667a31.311,31.311,0,0,1-31.31,31.31",
    transform: "translate(14.387 3.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    width: 274.972,
    height: 550.068,
    rx: 28.734,
    transform: "translate(174.856 36.949)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_950",
    "data-name": "Group 950",
    transform: "translate(183.082 45.421)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_949",
    "data-name": "Group 949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_948",
    "data-name": "Group 948",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M402.416,42.184H369.664a6.357,6.357,0,0,0-6.179,5.025,23.534,23.534,0,0,1-22.956,18.365H253.937a23.533,23.533,0,0,1-22.956-18.365,6.358,6.358,0,0,0-6.179-5.025H192.05a23.532,23.532,0,0,0-23.532,23.532v484.97a23.532,23.532,0,0,0,23.532,23.532H402.416a23.532,23.532,0,0,0,23.532-23.532V65.716a23.532,23.532,0,0,0-23.532-23.532",
    transform: "translate(-167.973 -41.639)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M402.416,42.184H369.664a6.357,6.357,0,0,0-6.179,5.025,23.534,23.534,0,0,1-22.956,18.365H253.937a23.533,23.533,0,0,1-22.956-18.365,6.358,6.358,0,0,0-6.179-5.025H192.05a23.532,23.532,0,0,0-23.532,23.532v484.97a23.532,23.532,0,0,0,23.532,23.532H402.416a23.532,23.532,0,0,0,23.532-23.532V65.716A23.532,23.532,0,0,0,402.416,42.184Z",
    transform: "translate(-167.973 -41.639)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M337.069,122.447a46.594,46.594,0,1,1-46.594-46.594,46.428,46.428,0,0,1,46.594,46.594",
    transform: "translate(21.865 6.801)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M304.237,110.56A16.257,16.257,0,1,1,287.981,94.3a16.257,16.257,0,0,1,16.257,16.257",
    transform: "translate(24.361 8.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M304.237,110.56A16.257,16.257,0,1,1,287.981,94.3,16.257,16.257,0,0,1,304.237,110.56Z",
    transform: "translate(24.361 8.455)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M289.345,164.121a45.66,45.66,0,0,1-32.852-13.8,33.853,33.853,0,0,1,65.7,0,45.66,45.66,0,0,1-32.852,13.8",
    transform: "translate(22.996 11.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M289.394,125.233a33.174,33.174,0,0,1,32.248,24.973,45.466,45.466,0,0,1-64.5,0,33.173,33.173,0,0,1,32.248-24.973m0-1.09a34.405,34.405,0,0,0-33.452,26.391,46.557,46.557,0,0,0,66.9,0,34.405,34.405,0,0,0-33.452-26.391",
    transform: "translate(22.946 11.13)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M353.427,191.92H231.153a7.5,7.5,0,1,1,0-15.009H353.427a7.5,7.5,0,0,1,0,15.009",
    transform: "translate(20.051 15.861)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M325.183,207.641H254.667a4.633,4.633,0,1,1,0-9.265h70.516a4.633,4.633,0,1,1,0,9.265",
    transform: "translate(22.417 17.785)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M375.727,249.6a24.177,24.177,0,1,1-24.176-24.176A24.176,24.176,0,0,1,375.727,249.6Z",
    transform: "translate(29.35 20.21)",
    fill: "none",
    stroke: "#ff6d0c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M346.41,258.17a5.666,5.666,0,0,1-4-1.541,5.6,5.6,0,0,1-1.542-4c-.09-1.582-.09-6.291,0-7.873a5.278,5.278,0,0,1,5.541-5.534c.728-.041,2.237-.068,3.936-.068s3.2.026,3.937.068a5.284,5.284,0,0,1,5.54,5.539c.09,1.581.09,6.287,0,7.868a5.284,5.284,0,0,1-5.54,5.539c-.729.041-2.237.068-3.937.068s-3.208-.026-3.936-.068m-1.1-9.17a5.148,5.148,0,1,0,5.149-5.146h0A5.154,5.154,0,0,0,345.309,249M354.3,243.6a1.141,1.141,0,1,0,1.141-1.141A1.141,1.141,0,0,0,354.3,243.6ZM346.519,249a3.937,3.937,0,1,1,3.938,3.936h0A3.936,3.936,0,0,1,346.519,249Z",
    transform: "translate(30.554 21.441)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M312.808,249.6a24.177,24.177,0,1,1-24.176-24.176A24.176,24.176,0,0,1,312.808,249.6Z",
    transform: "translate(23.71 20.21)",
    fill: "none",
    stroke: "#ff6d0c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M295.436,244.495c.013.179.013.356.013.535a11.618,11.618,0,0,1-11.537,11.7h-.161a11.621,11.621,0,0,1-6.313-1.846,8.626,8.626,0,0,0,.993.051,8.238,8.238,0,0,0,5.109-1.757,4.118,4.118,0,0,1-3.844-2.852,5.154,5.154,0,0,0,.777.063,4.365,4.365,0,0,0,1.082-.139,4.113,4.113,0,0,1-3.3-4.032v-.054a4.136,4.136,0,0,0,1.858.522,4.118,4.118,0,0,1-1.277-5.5,11.686,11.686,0,0,0,8.478,4.3,4.634,4.634,0,0,1-.1-.941,4.116,4.116,0,0,1,7.113-2.813,8.081,8.081,0,0,0,2.615-.993,4.1,4.1,0,0,1-1.812,2.265,8.234,8.234,0,0,0,2.368-.636,8.823,8.823,0,0,1-2.062,2.126",
    transform: "translate(24.873 21.556)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M249.964,249.6a24.177,24.177,0,1,1-24.176-24.176A24.176,24.176,0,0,1,249.964,249.6Z",
    transform: "translate(18.075 20.21)",
    fill: "none",
    stroke: "#ff6d0c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M228.938,250l.559-3.65h-3.5v-2.369A1.826,1.826,0,0,1,227.65,242a1.859,1.859,0,0,1,.4.009h1.592V238.9a19.523,19.523,0,0,0-2.827-.246c-2.886,0-4.77,1.743-4.77,4.913v2.782h-3.208V250h3.208v8.826h3.946V250Z",
    transform: "translate(19.62 21.397)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M394.559,358.371H197a12.256,12.256,0,0,1-12.256-12.255V299.334A12.256,12.256,0,0,1,197,287.079H394.559a12.255,12.255,0,0,1,12.255,12.255v46.781a12.255,12.255,0,0,1-12.255,12.255",
    transform: "translate(16.563 25.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_953",
    "data-name": "Group 953",
    transform: "translate(278.343 328.082)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_952",
    "data-name": "Group 952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_951",
    "data-name": "Group 951",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M260.279,310.263H380.338a4.337,4.337,0,0,0,0-8.675H260.279a4.337,4.337,0,0,0,0,8.675",
    transform: "translate(-255.397 -301.043)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M260.279,310.263H380.338a4.337,4.337,0,0,0,0-8.675H260.279a4.337,4.337,0,0,0,0,8.675Z",
    transform: "translate(-255.397 -301.043)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M296.036,315.67H260.279a4.337,4.337,0,0,0,0,8.675h35.757a4.337,4.337,0,0,0,0-8.675",
    transform: "translate(-255.397 -299.781)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M296.036,315.67H260.279a4.337,4.337,0,0,0,0,8.675h35.757a4.337,4.337,0,0,0,0-8.675Z",
    transform: "translate(-255.397 -299.781)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M376.188,315.67H306.57a4.337,4.337,0,1,0,0,8.675h69.618a4.337,4.337,0,0,0,0-8.675",
    transform: "translate(-251.247 -299.781)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M376.188,315.67H306.57a4.337,4.337,0,1,0,0,8.675h69.618a4.337,4.337,0,0,0,0-8.675Z",
    transform: "translate(-251.247 -299.781)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M345.416,329.751H260.279a4.337,4.337,0,0,0,0,8.675h85.137a4.337,4.337,0,0,0,0-8.675",
    transform: "translate(-255.397 -298.518)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M345.416,329.751H260.279a4.337,4.337,0,0,0,0,8.675h85.137a4.337,4.337,0,0,0,0-8.675Z",
    transform: "translate(-255.397 -298.518)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M243.273,321.623a23.986,23.986,0,1,1-23.985-23.985,23.985,23.985,0,0,1,23.985,23.985",
    transform: "translate(17.51 26.685)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M218.091,309.712a9.448,9.448,0,0,0-9.448,9.448c0,6.746,9.448,14.144,9.448,14.144s9.447-7.4,9.447-14.144a9.448,9.448,0,0,0-9.447-9.448m0,13.3a3.854,3.854,0,1,1,3.853-3.854,3.853,3.853,0,0,1-3.853,3.854",
    transform: "translate(18.706 27.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M394.559,438.317H197a12.256,12.256,0,0,1-12.256-12.255V379.28A12.256,12.256,0,0,1,197,367.025H394.559a12.255,12.255,0,0,1,12.255,12.255v46.781a12.255,12.255,0,0,1-12.255,12.255",
    transform: "translate(16.563 32.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_956",
    "data-name": "Group 956",
    transform: "translate(278.343 415.196)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_955",
    "data-name": "Group 955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_954",
    "data-name": "Group 954",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M260.279,390.209H380.338a4.337,4.337,0,0,0,0-8.675H260.279a4.337,4.337,0,0,0,0,8.675",
    transform: "translate(-255.397 -380.99)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M260.279,390.209H380.338a4.337,4.337,0,0,0,0-8.675H260.279a4.337,4.337,0,0,0,0,8.675Z",
    transform: "translate(-255.397 -380.99)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M296.036,395.616H260.279a4.337,4.337,0,0,0,0,8.675h35.757a4.337,4.337,0,0,0,0-8.675",
    transform: "translate(-255.397 -379.728)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M296.036,395.616H260.279a4.337,4.337,0,0,0,0,8.675h35.757a4.337,4.337,0,0,0,0-8.675Z",
    transform: "translate(-255.397 -379.728)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M376.188,395.616H306.57a4.337,4.337,0,1,0,0,8.675h69.618a4.337,4.337,0,0,0,0-8.675",
    transform: "translate(-251.247 -379.728)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M376.188,395.616H306.57a4.337,4.337,0,1,0,0,8.675h69.618a4.337,4.337,0,0,0,0-8.675Z",
    transform: "translate(-251.247 -379.728)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M345.416,409.7H260.279a4.337,4.337,0,0,0,0,8.675h85.137a4.337,4.337,0,0,0,0-8.675",
    transform: "translate(-255.397 -378.465)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M345.416,409.7H260.279a4.337,4.337,0,0,0,0,8.675h85.137a4.337,4.337,0,0,0,0-8.675Z",
    transform: "translate(-255.397 -378.465)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M243.273,401.569a23.986,23.986,0,1,1-23.985-23.985,23.985,23.985,0,0,1,23.985,23.985",
    transform: "translate(17.51 33.852)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M207.551,397.034v8.122a3.283,3.283,0,0,0,3.27,3.28h14.726a3.292,3.292,0,0,0,3.28-3.28v-8.122Zm7.173,8.6h-2.505a1.45,1.45,0,1,1,0-2.9h2.505a1.45,1.45,0,0,1,0,2.9",
    transform: "translate(18.608 35.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M228.812,395.119a3.279,3.279,0,0,0-3.262-3.139H210.824a3.278,3.278,0,0,0-3.262,3.139Z",
    transform: "translate(18.609 35.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M394.559,518.264H197a12.256,12.256,0,0,1-12.256-12.255V459.227A12.257,12.257,0,0,1,197,446.971H394.559a12.256,12.256,0,0,1,12.255,12.256v46.781a12.255,12.255,0,0,1-12.255,12.255",
    transform: "translate(16.563 40.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_959",
    "data-name": "Group 959",
    transform: "translate(278.343 502.31)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_958",
    "data-name": "Group 958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_957",
    "data-name": "Group 957",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M260.279,470.156H380.338a4.337,4.337,0,0,0,0-8.675H260.279a4.337,4.337,0,0,0,0,8.675",
    transform: "translate(-255.397 -460.936)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M260.279,470.156H380.338a4.337,4.337,0,0,0,0-8.675H260.279a4.337,4.337,0,0,0,0,8.675Z",
    transform: "translate(-255.397 -460.936)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M296.036,475.562H260.279a4.337,4.337,0,0,0,0,8.675h35.757a4.337,4.337,0,0,0,0-8.675",
    transform: "translate(-255.397 -459.674)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M296.036,475.562H260.279a4.337,4.337,0,0,0,0,8.675h35.757a4.337,4.337,0,0,0,0-8.675Z",
    transform: "translate(-255.397 -459.674)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M376.188,475.562H306.57a4.337,4.337,0,1,0,0,8.675h69.618a4.337,4.337,0,0,0,0-8.675",
    transform: "translate(-251.247 -459.674)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M376.188,475.562H306.57a4.337,4.337,0,1,0,0,8.675h69.618a4.337,4.337,0,0,0,0-8.675Z",
    transform: "translate(-251.247 -459.674)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M345.416,489.644H260.279a4.337,4.337,0,0,0,0,8.675h85.137a4.337,4.337,0,0,0,0-8.675",
    transform: "translate(-255.397 -458.411)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M345.416,489.644H260.279a4.337,4.337,0,0,0,0,8.675h85.137a4.337,4.337,0,0,0,0-8.675Z",
    transform: "translate(-255.397 -458.411)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M242.567,481.518a23.977,23.977,0,0,1-39.392,18.372V463.147a23.977,23.977,0,0,1,39.392,18.372",
    transform: "translate(18.216 41.02)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M223.039,476.565a9.55,9.55,0,0,1,5.936,2.137V473a1.277,1.277,0,0,0-1.187-1.189H226.6V470.63a1.187,1.187,0,1,0-2.374,0v1.186H212.352V470.63a1.187,1.187,0,1,0-2.374,0v1.186H207.6A1.191,1.191,0,0,0,206.416,473v16.622a1.19,1.19,0,0,0,1.188,1.188h7.243a9.453,9.453,0,0,1,8.192-14.248",
    transform: "translate(18.506 42.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M222.258,478.159a7.124,7.124,0,1,0,7.124,7.123,7.145,7.145,0,0,0-7.124-7.123m2.374,8.311h-2.374a1.122,1.122,0,0,1-1.188-1.188V481.72a1.187,1.187,0,0,1,2.374,0V484.1h1.188a1.187,1.187,0,1,1,0,2.374",
    transform: "translate(19.288 42.869)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962",
    transform: "translate(174.856 107.741)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_961",
    "data-name": "Group 961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_960",
    "data-name": "Group 960",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M211.542,98.876H160.468V223.391h51.074a19.005,19.005,0,0,0,19-19V117.881a19.005,19.005,0,0,0-19-19",
    transform: "translate(-160.469 -98.876)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M420.3,318.566H345.145A13.077,13.077,0,0,0,332.106,331.6v125.75a13.077,13.077,0,0,0,13.039,13.038H420.3Z",
    transform: "translate(-145.081 -79.18)",
    fill: "#4e3057"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M234.5,207.508H80.386a19.005,19.005,0,0,1-19.006-19V102a19.005,19.005,0,0,1,19.006-19H234.5a19.005,19.005,0,0,1,19,19V188.5a19.005,19.005,0,0,1-19,19",
    transform: "translate(5.503 7.441)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_236",
    "data-name": "Rectangle 236",
    d: "M2.869,0H9.2a2.869,2.869,0,0,1,2.869,2.869V13.064A2.868,2.868,0,0,1,9.2,15.932H2.868A2.868,2.868,0,0,1,0,13.064V2.869A2.869,2.869,0,0,1,2.869,0Z",
    transform: "translate(97.759 117.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    width: 10.966,
    height: 8.381,
    transform: "translate(111.124 121.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M95.849,106.864h2.258a4.429,4.429,0,0,1,4.372,3.775H113.5v-3.171a5.586,5.586,0,0,0-5.569-5.569H95.849Z",
    transform: "translate(8.593 9.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    width: 10.966,
    height: 8.381,
    transform: "translate(85.494 121.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M102.479,119.995a4.429,4.429,0,0,1-4.372,3.776H95.848v4.964h12.081a5.586,5.586,0,0,0,5.569-5.569v-3.171Z",
    transform: "translate(8.593 10.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M96.109,123.77H93.851a4.428,4.428,0,0,1-4.372-3.776H78.46v3.171a5.586,5.586,0,0,0,5.569,5.569h12.08Z",
    transform: "translate(7.034 10.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M89.48,110.638a4.427,4.427,0,0,1,4.372-3.775h2.258V101.9H84.029a5.586,5.586,0,0,0-5.569,5.569v3.171Z",
    transform: "translate(7.034 9.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M100.622,151.5H84.809a6.373,6.373,0,1,0,0,12.746h15.813a6.373,6.373,0,1,0,0-12.746",
    transform: "translate(7.032 13.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M139.288,151.5H123.475a6.373,6.373,0,1,0,0,12.746h15.813a6.373,6.373,0,1,0,0-12.746",
    transform: "translate(10.499 13.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M177.954,151.5H162.141a6.373,6.373,0,1,0,0,12.746h15.813a6.373,6.373,0,1,0,0-12.746",
    transform: "translate(13.965 13.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M216.621,151.5H200.808a6.373,6.373,0,1,0,0,12.746h15.813a6.373,6.373,0,1,0,0-12.746",
    transform: "translate(17.432 13.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M187.745,120.357a18.861,18.861,0,0,1,8.188-15.56,18.884,18.884,0,1,0,0,31.121,18.861,18.861,0,0,1-8.188-15.56",
    transform: "translate(14.914 9.097)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M204.195,103.652a16.7,16.7,0,1,1-6.853,31.941,21.052,21.052,0,0,0,0-30.473,16.627,16.627,0,0,1,6.853-1.468m0-2.179A18.794,18.794,0,0,0,193.5,104.8a18.881,18.881,0,0,1,0,31.122,18.883,18.883,0,1,0,10.695-34.444",
    transform: "translate(17.348 9.097)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M134.8,180.624H82.834a4.373,4.373,0,1,1,0-8.747H134.8a4.373,4.373,0,1,1,0,8.747",
    transform: "translate(7.034 15.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M484.7,453.974H358.947a13.076,13.076,0,0,1-13.038-13.038V315.186a13.076,13.076,0,0,1,13.038-13.038H484.7a13.076,13.076,0,0,1,13.038,13.038v125.75A13.076,13.076,0,0,1,484.7,453.974",
    transform: "translate(31.012 27.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 151.826,
    height: 151.826,
    rx: 11.965,
    transform: "translate(376.921 329.237)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965",
    transform: "translate(389.75 371.308)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M370.5,341.258h-6.346a6,6,0,0,0-5.977,5.978v6.345a6,6,0,0,0,5.977,5.978H370.5a6,6,0,0,0,5.978-5.978v-6.345a6,6,0,0,0-5.978-5.978",
    transform: "translate(-357.637 -340.713)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    d: "M5.486,0h7.33A5.485,5.485,0,0,1,18.3,5.485v7.33A5.486,5.486,0,0,1,12.815,18.3H5.486A5.486,5.486,0,0,1,0,12.815V5.486A5.486,5.486,0,0,1,5.486,0Z",
    transform: "translate(0.545 0.545)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_968",
    "data-name": "Group 968",
    transform: "translate(416.444 371.308)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_967",
    "data-name": "Group 967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_966",
    "data-name": "Group 966",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M395,341.258h-6.346a6,6,0,0,0-5.977,5.978v6.345a6,6,0,0,0,5.977,5.978H395a6,6,0,0,0,5.978-5.978v-6.345A6,6,0,0,0,395,341.258",
    transform: "translate(-382.135 -340.713)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    d: "M5.486,0h7.33A5.485,5.485,0,0,1,18.3,5.485v7.33A5.486,5.486,0,0,1,12.815,18.3H5.486A5.486,5.486,0,0,1,0,12.815V5.486A5.486,5.486,0,0,1,5.486,0Z",
    transform: "translate(0.545 0.545)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_971",
    "data-name": "Group 971",
    transform: "translate(443.138 371.308)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_970",
    "data-name": "Group 970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_969",
    "data-name": "Group 969",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M419.5,341.258h-6.346a6,6,0,0,0-5.977,5.978v6.345a6,6,0,0,0,5.977,5.978H419.5a6,6,0,0,0,5.978-5.978v-6.345a6,6,0,0,0-5.978-5.978",
    transform: "translate(-406.633 -340.713)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    d: "M5.486,0h7.33A5.485,5.485,0,0,1,18.3,5.485v7.33A5.486,5.486,0,0,1,12.815,18.3H5.486A5.486,5.486,0,0,1,0,12.815V5.486A5.486,5.486,0,0,1,5.486,0Z",
    transform: "translate(0.545 0.545)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_974",
    "data-name": "Group 974",
    transform: "translate(469.833 371.308)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_973",
    "data-name": "Group 973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_972",
    "data-name": "Group 972",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M444,341.258h-6.346a6,6,0,0,0-5.977,5.978v6.345a6,6,0,0,0,5.977,5.978H444a6,6,0,0,0,5.978-5.978v-6.345A6,6,0,0,0,444,341.258",
    transform: "translate(-431.131 -340.713)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_246",
    "data-name": "Rectangle 246",
    d: "M5.486,0h7.33A5.485,5.485,0,0,1,18.3,5.485v7.33A5.486,5.486,0,0,1,12.815,18.3H5.486A5.486,5.486,0,0,1,0,12.815V5.486A5.486,5.486,0,0,1,5.486,0Z",
    transform: "translate(0.545 0.545)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_977",
    "data-name": "Group 977",
    transform: "translate(496.527 371.308)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_976",
    "data-name": "Group 976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_975",
    "data-name": "Group 975",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M468.5,341.258h-6.346a6,6,0,0,0-5.977,5.978v6.345a6,6,0,0,0,5.977,5.978H468.5a6,6,0,0,0,5.978-5.978v-6.345a6,6,0,0,0-5.978-5.978",
    transform: "translate(-455.629 -340.713)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_248",
    "data-name": "Rectangle 248",
    d: "M5.486,0h7.33A5.485,5.485,0,0,1,18.3,5.485v7.33A5.486,5.486,0,0,1,12.815,18.3H5.486A5.486,5.486,0,0,1,0,12.815V5.486A5.486,5.486,0,0,1,5.486,0Z",
    transform: "translate(0.546 0.545)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_980",
    "data-name": "Group 980",
    transform: "translate(389.75 397.335)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_979",
    "data-name": "Group 979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_978",
    "data-name": "Group 978",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M370.5,365.143h-6.346a6,6,0,0,0-5.977,5.978v6.345a6,6,0,0,0,5.977,5.978H370.5a6,6,0,0,0,5.978-5.978v-6.345a6,6,0,0,0-5.978-5.978",
    transform: "translate(-357.637 -364.598)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    d: "M5.486,0h7.33A5.485,5.485,0,0,1,18.3,5.485v7.33A5.486,5.486,0,0,1,12.815,18.3H5.486A5.486,5.486,0,0,1,0,12.815V5.486A5.486,5.486,0,0,1,5.486,0Z",
    transform: "translate(0.545 0.545)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M395,365.143h-6.346a6,6,0,0,0-5.977,5.978v6.345a6,6,0,0,0,5.977,5.978H395a6,6,0,0,0,5.978-5.978v-6.345A6,6,0,0,0,395,365.143",
    transform: "translate(34.309 32.737)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_983",
    "data-name": "Group 983",
    transform: "translate(443.138 397.335)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_982",
    "data-name": "Group 982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_981",
    "data-name": "Group 981",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M419.5,365.143h-6.346a6,6,0,0,0-5.977,5.978v6.345a6,6,0,0,0,5.977,5.978H419.5a6,6,0,0,0,5.978-5.978v-6.345a6,6,0,0,0-5.978-5.978",
    transform: "translate(-406.633 -364.598)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    d: "M5.486,0h7.33A5.485,5.485,0,0,1,18.3,5.485v7.33A5.486,5.486,0,0,1,12.815,18.3H5.486A5.486,5.486,0,0,1,0,12.815V5.486A5.486,5.486,0,0,1,5.486,0Z",
    transform: "translate(0.545 0.545)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_986",
    "data-name": "Group 986",
    transform: "translate(469.833 397.335)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_985",
    "data-name": "Group 985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_984",
    "data-name": "Group 984",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M444,365.143h-6.346a6,6,0,0,0-5.977,5.978v6.345a6,6,0,0,0,5.977,5.978H444a6,6,0,0,0,5.978-5.978v-6.345A6,6,0,0,0,444,365.143",
    transform: "translate(-431.131 -364.598)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    d: "M5.486,0h7.33A5.485,5.485,0,0,1,18.3,5.485v7.33A5.486,5.486,0,0,1,12.815,18.3H5.486A5.486,5.486,0,0,1,0,12.815V5.486A5.486,5.486,0,0,1,5.486,0Z",
    transform: "translate(0.545 0.545)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_989",
    "data-name": "Group 989",
    transform: "translate(496.527 397.335)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_988",
    "data-name": "Group 988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_987",
    "data-name": "Group 987",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M468.5,365.143h-6.346a6,6,0,0,0-5.977,5.978v6.345a6,6,0,0,0,5.977,5.978H468.5a6,6,0,0,0,5.978-5.978v-6.345a6,6,0,0,0-5.978-5.978",
    transform: "translate(-455.629 -364.598)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    d: "M5.486,0h7.33A5.485,5.485,0,0,1,18.3,5.485v7.33A5.486,5.486,0,0,1,12.815,18.3H5.486A5.486,5.486,0,0,1,0,12.815V5.486A5.486,5.486,0,0,1,5.486,0Z",
    transform: "translate(0.546 0.545)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_992",
    "data-name": "Group 992",
    transform: "translate(389.75 423.361)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_991",
    "data-name": "Group 991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_990",
    "data-name": "Group 990",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M370.5,389.028h-6.346a6,6,0,0,0-5.977,5.978v6.345a6,6,0,0,0,5.977,5.978H370.5a6,6,0,0,0,5.978-5.978v-6.345a6,6,0,0,0-5.978-5.978",
    transform: "translate(-357.637 -388.483)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    d: "M5.486,0h7.33A5.485,5.485,0,0,1,18.3,5.485v7.33A5.486,5.486,0,0,1,12.815,18.3H5.486A5.486,5.486,0,0,1,0,12.815V5.486A5.486,5.486,0,0,1,5.486,0Z",
    transform: "translate(0.545 0.544)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_995",
    "data-name": "Group 995",
    transform: "translate(416.444 423.361)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_994",
    "data-name": "Group 994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_993",
    "data-name": "Group 993",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M395,389.028h-6.346a6,6,0,0,0-5.977,5.978v6.345a6,6,0,0,0,5.977,5.978H395a6,6,0,0,0,5.978-5.978v-6.345A6,6,0,0,0,395,389.028",
    transform: "translate(-382.135 -388.483)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 18.301,
    height: 18.301,
    rx: 5.486,
    transform: "translate(0.545 0.544)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998",
    transform: "translate(443.138 423.361)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M419.5,389.028h-6.346a6,6,0,0,0-5.977,5.978v6.345a6,6,0,0,0,5.977,5.978H419.5a6,6,0,0,0,5.978-5.978v-6.345a6,6,0,0,0-5.978-5.978",
    transform: "translate(-406.633 -388.483)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    d: "M5.486,0h7.33A5.485,5.485,0,0,1,18.3,5.485v7.33A5.486,5.486,0,0,1,12.815,18.3H5.486A5.486,5.486,0,0,1,0,12.815V5.486A5.486,5.486,0,0,1,5.486,0Z",
    transform: "translate(0.545 0.544)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001",
    transform: "translate(469.833 423.361)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1000",
    "data-name": "Group 1000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M444,389.028h-6.346a6,6,0,0,0-5.977,5.978v6.345a6,6,0,0,0,5.977,5.978H444a6,6,0,0,0,5.978-5.978v-6.345A6,6,0,0,0,444,389.028",
    transform: "translate(-431.131 -388.483)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    d: "M5.486,0h7.33A5.485,5.485,0,0,1,18.3,5.485v7.33A5.486,5.486,0,0,1,12.815,18.3H5.486A5.486,5.486,0,0,1,0,12.815V5.486A5.486,5.486,0,0,1,5.486,0Z",
    transform: "translate(0.545 0.544)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004",
    transform: "translate(496.527 423.361)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M468.5,389.028h-6.346a6,6,0,0,0-5.977,5.978v6.345a6,6,0,0,0,5.977,5.978H468.5a6,6,0,0,0,5.978-5.978v-6.345a6,6,0,0,0-5.978-5.978",
    transform: "translate(-455.629 -388.483)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    d: "M5.486,0h7.33A5.485,5.485,0,0,1,18.3,5.485v7.33A5.486,5.486,0,0,1,12.815,18.3H5.486A5.486,5.486,0,0,1,0,12.815V5.486A5.486,5.486,0,0,1,5.486,0Z",
    transform: "translate(0.546 0.544)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007",
    transform: "translate(389.75 449.388)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M370.5,412.912h-6.346a6,6,0,0,0-5.977,5.978v6.345a6,6,0,0,0,5.977,5.978H370.5a6,6,0,0,0,5.978-5.978V418.89a6,6,0,0,0-5.978-5.978",
    transform: "translate(-357.637 -412.368)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    d: "M5.486,0h7.33A5.485,5.485,0,0,1,18.3,5.485v7.33A5.486,5.486,0,0,1,12.815,18.3H5.486A5.486,5.486,0,0,1,0,12.815V5.486A5.486,5.486,0,0,1,5.486,0Z",
    transform: "translate(0.545 0.544)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010",
    transform: "translate(416.444 449.388)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M395,412.912h-6.346a6,6,0,0,0-5.977,5.978v6.345a6,6,0,0,0,5.977,5.978H395a6,6,0,0,0,5.978-5.978V418.89A6,6,0,0,0,395,412.912",
    transform: "translate(-382.135 -412.368)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_270",
    "data-name": "Rectangle 270",
    d: "M5.486,0h7.33A5.485,5.485,0,0,1,18.3,5.485v7.33A5.486,5.486,0,0,1,12.815,18.3H5.486A5.486,5.486,0,0,1,0,12.815V5.486A5.486,5.486,0,0,1,5.486,0Z",
    transform: "translate(0.545 0.544)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013",
    transform: "translate(443.138 449.388)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1012",
    "data-name": "Group 1012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M419.5,412.912h-6.346a6,6,0,0,0-5.977,5.978v6.345a6,6,0,0,0,5.977,5.978H419.5a6,6,0,0,0,5.978-5.978V418.89a6,6,0,0,0-5.978-5.978",
    transform: "translate(-406.633 -412.368)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_272",
    "data-name": "Rectangle 272",
    d: "M5.486,0h7.33A5.485,5.485,0,0,1,18.3,5.485v7.33A5.486,5.486,0,0,1,12.815,18.3H5.486A5.486,5.486,0,0,1,0,12.815V5.486A5.486,5.486,0,0,1,5.486,0Z",
    transform: "translate(0.545 0.544)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M454.7,326.063H383.072a4.4,4.4,0,1,1,0-8.792H454.7a4.4,4.4,0,0,1,0,8.792",
    transform: "translate(33.95 28.445)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M363.889,327.41a1.082,1.082,0,0,1-.77-.319l-4.551-4.549a1.089,1.089,0,0,1,0-1.541l4.551-4.551a1.089,1.089,0,0,1,1.541,1.541l-3.781,3.781,3.781,3.78a1.089,1.089,0,0,1-.77,1.859",
    transform: "translate(32.118 28.342)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M467.817,327.41a1.089,1.089,0,0,1-.77-1.859l3.78-3.78-3.78-3.781a1.089,1.089,0,0,1,1.54-1.541L473.138,321a1.089,1.089,0,0,1,0,1.541l-4.551,4.549a1.081,1.081,0,0,1-.769.319",
    transform: "translate(41.844 28.342)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M92.846,541.077H41.374s-.185-1.717-.324-4.322c-.368-6.348-.518-17.94,2.709-22.411,4.528-6.3,25.626,4.92,25.626,4.92s9.633,8.758,15,11.062,6.914.761,7.685,4.609c.127.656.242,1.267.335,1.82a30.354,30.354,0,0,1,.438,4.322",
    transform: "translate(3.663 45.941)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M92.846,541.077H41.374s-.185-1.717-.324-4.322c-.368-6.348-.518-17.94,2.709-22.411,4.528-6.3,25.626,4.92,25.626,4.92s9.633,8.758,15,11.062,6.914.761,7.685,4.609c.127.656.242,1.267.335,1.82A30.354,30.354,0,0,1,92.846,541.077Z",
    transform: "translate(3.663 45.941)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M92.831,539.075H41.359s-.185-1.717-.324-4.322H92.393a30.354,30.354,0,0,1,.438,4.322",
    transform: "translate(3.679 47.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M92.831,539.075H41.359s-.185-1.717-.324-4.322H92.393A30.354,30.354,0,0,1,92.831,539.075Z",
    transform: "translate(3.679 47.943)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M46.16,343.542l3.132,80.525s-9.842,22.368-7.158,39.816-.895,74.263-.895,74.263.895,2.684,11.631,2.684S65.4,533.225,65.4,533.225s8.947-102,9.842-109.6,11.184-77.842,11.184-77.842Z",
    transform: "translate(3.697 30.8)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M46.16,343.542l3.132,80.525s-9.842,22.368-7.158,39.816-.895,74.263-.895,74.263.895,2.684,11.631,2.684S65.4,533.225,65.4,533.225s8.947-102,9.842-109.6,11.184-77.842,11.184-77.842Z",
    transform: "translate(3.697 30.8)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M105.573,541.077H54.1s-.185-1.717-.323-4.322c-.369-6.348-.519-17.94,2.708-22.411,4.528-6.3,25.626,4.92,25.626,4.92s9.633,8.758,15,11.062,6.914.761,7.685,4.609c.127.656.242,1.267.335,1.82a30.354,30.354,0,0,1,.438,4.322",
    transform: "translate(4.805 45.941)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M105.573,541.077H54.1s-.185-1.717-.323-4.322c-.369-6.348-.519-17.94,2.708-22.411,4.528-6.3,25.626,4.92,25.626,4.92s9.633,8.758,15,11.062,6.914.761,7.685,4.609c.127.656.242,1.267.335,1.82A30.354,30.354,0,0,1,105.573,541.077Z",
    transform: "translate(4.805 45.941)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M105.558,539.075H54.086s-.185-1.717-.323-4.322h51.356a30.354,30.354,0,0,1,.438,4.322",
    transform: "translate(4.82 47.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M105.558,539.075H54.086s-.185-1.717-.323-4.322h51.356A30.354,30.354,0,0,1,105.558,539.075Z",
    transform: "translate(4.82 47.943)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M89.938,341.553s4.616,31.636,3.079,46.231-3.841,65.3-6.914,86.037-5.3,53.159-5.3,53.159l2.458,1.844v6.146s-10.448,2.458-14.75,3.073c-2.908.415-8.4.985-11.654,1.311a1.926,1.926,0,0,1-2.076-2.312l1.438-6.988,1.612-8.338s-8.6-53.271-7.065-62.488,6.914-30.728,6.914-33.033S50,383.942,48.462,377.029s-7.682-25.35-7.682-35.336,49.158-.139,49.158-.139",
    transform: "translate(3.656 30.233)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M89.938,341.553s4.616,31.636,3.079,46.231-3.841,65.3-6.914,86.037-5.3,53.159-5.3,53.159l2.458,1.844v6.146s-10.448,2.458-14.75,3.073c-2.908.415-8.4.985-11.654,1.311a1.926,1.926,0,0,1-2.076-2.312l1.438-6.988,1.612-8.338s-8.6-53.271-7.065-62.488,6.914-30.728,6.914-33.033S50,383.942,48.462,377.029s-7.682-25.35-7.682-35.336S89.938,341.553,89.938,341.553Z",
    transform: "translate(3.656 30.233)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M76.03,245.094s11.138,15.748,14.595,18.821,14.595,9.218,14.211,14.211-1.535,10.755-7.682,13.444-19.205-6.146-19.205-6.146Z",
    transform: "translate(6.816 21.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M76.03,245.094s11.138,15.748,14.595,18.821,14.595,9.218,14.211,14.211-1.535,10.755-7.682,13.444-19.205-6.146-19.205-6.146Z",
    transform: "translate(6.816 21.974)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M91.908,263.473s-3.841,9.987-4.225,13.828-.768,10.37,2.3,13.058a19.164,19.164,0,0,0,10.37,4.226c2.3,0,3.073-15.364,3.456-18.052s2.689-8.45.385-11.14-9.218-3.073-12.291-1.92",
    transform: "translate(7.838 23.567)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M91.908,263.473s-3.841,9.987-4.225,13.828-.768,10.37,2.3,13.058a19.164,19.164,0,0,0,10.37,4.226c2.3,0,3.073-15.364,3.456-18.052s2.689-8.45.385-11.14S94.981,262.321,91.908,263.473Z",
    transform: "translate(7.838 23.567)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M100.255,232.712c-2.7,1.121-5.647-1.11-7.275-3.545s-2.847-5.382-5.412-6.8c-.8-.443-1.769-.777-2.166-1.6-.676-1.4.986-2.967,2.544-2.983s6.118,3.668,7.6,4.162c5.1,1.7,7.433-4.019,12.8-3.7a2.831,2.831,0,0,1,1.775.562c.561.508.9,5.916.977,6.669.949,9.336-.19,14.35-.168,32.058.009,6.815.361,18.307.3,29.249-.024,4.434-.5,6.884-6.943,10.443s-12.4-7.3-12.62-10.275c-.34-4.6,1.68-10.026,2.658-14.458,2.126-9.636,5.768-29.888,5.936-39.775",
    transform: "translate(7.643 19.525)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M100.255,232.712c-2.7,1.121-5.647-1.11-7.275-3.545s-2.847-5.382-5.412-6.8c-.8-.443-1.769-.777-2.166-1.6-.676-1.4.986-2.967,2.544-2.983s6.118,3.668,7.6,4.162c5.1,1.7,7.433-4.019,12.8-3.7a2.831,2.831,0,0,1,1.775.562c.561.508.9,5.916.977,6.669.949,9.336-.19,14.35-.168,32.058.009,6.815.361,18.307.3,29.249-.024,4.434-.5,6.884-6.943,10.443s-12.4-7.3-12.62-10.275c-.34-4.6,1.68-10.026,2.658-14.458C96.444,262.851,100.086,242.6,100.255,232.712Z",
    transform: "translate(7.643 19.525)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M97.585,217.494s-.267-.413-.7-.983c-.976-1.294-2.788-3.4-4.208-3.337-2.045.093-8.329,4.421-6.86,6.293s6.712-2.243,6.712-2.243l3.38,6.214,5.174-.732Z",
    transform: "translate(7.674 19.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M97.585,217.494s-.267-.413-.7-.983c-.976-1.294-2.788-3.4-4.208-3.337-2.045.093-8.329,4.421-6.86,6.293s6.712-2.243,6.712-2.243l3.38,6.214,5.174-.732Z",
    transform: "translate(7.674 19.112)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M97.621,216.643s-3.114,1.381-2.818,6.6,2.688,5.866,3.7,5.285c.7-.4,4.765-1.12,7.2-1.524a2.535,2.535,0,0,0,2.079-2.017c.219-1.139.646-2.991,1.471-5.96,1.835-6.6-11.638-2.381-11.638-2.381",
    transform: "translate(8.498 19.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M97.621,216.643s-3.114,1.381-2.818,6.6,2.688,5.866,3.7,5.285c.7-.4,4.765-1.12,7.2-1.524a2.535,2.535,0,0,0,2.079-2.017c.219-1.139.646-2.991,1.471-5.96C111.094,212.424,97.621,216.643,97.621,216.643Z",
    transform: "translate(8.498 19.304)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M99.526,216.271a14.822,14.822,0,0,0-.125,11.4",
    transform: "translate(8.816 19.39)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M103.931,215.5s-2.434,7.147-.568,11.612",
    transform: "translate(9.204 19.32)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M100.7,229.232s.163.814,2.492,2.161,4.863-.495,5.328-.588",
    transform: "translate(9.029 20.552)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M57.357,210.5l-1.019,18.906L76.669,242.09l5.744-25.275L66.165,181.494s-4.523-2.711-8.15,5.058.291,15.483.291,15.483Z",
    transform: "translate(5.051 16.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M57.357,210.5l-1.019,18.906L76.669,242.09l5.744-25.275L66.165,181.494s-4.523-2.711-8.15,5.058.291,15.483.291,15.483Z",
    transform: "translate(5.051 16.231)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M93.607,179.977l5.9,15.34-3.986,2.727s3.715,16.792,1.439,20.173-16.356,2.574-18.462,2.1S66.828,190.99,66.828,190.99s-.579-4.472-4.036-.562,3.355,11.749,3.355,11.749L58.928,212.5S38.02,195.341,38.835,185.514s11.232-22.521,33.243-26.2,30.375,12.928,28.277,16.7-6.747,3.96-6.747,3.96",
    transform: "translate(3.48 14.236)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M93.607,179.977l5.9,15.34-3.986,2.727s3.715,16.792,1.439,20.173-16.356,2.574-18.462,2.1S66.828,190.99,66.828,190.99s-.579-4.472-4.036-.562,3.355,11.749,3.355,11.749L58.928,212.5S38.02,195.341,38.835,185.514s11.232-22.521,33.243-26.2,30.375,12.928,28.277,16.7S93.607,179.977,93.607,179.977Z",
    transform: "translate(3.48 14.236)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M88.854,200.654c-2.543.663-2.4,6.276-2.4,6.276a5.172,5.172,0,0,0,3.683-.226,15.031,15.031,0,0,0,2.909-1.832c-.216-1.8-.495-3.6-.768-5.194-1.114.335-2.367.7-3.424.975",
    transform: "translate(7.751 17.902)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M88.854,200.654c-2.543.663-2.4,6.276-2.4,6.276a5.172,5.172,0,0,0,3.683-.226,15.031,15.031,0,0,0,2.909-1.832c-.216-1.8-.495-3.6-.768-5.194C91.164,200.014,89.911,200.379,88.854,200.654Z",
    transform: "translate(7.751 17.902)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M74.759,184.3c-.7,2.677-7.579,5.277-7.579,5.277l1.762,3.943S74.579,206.139,77,208.372s5.748,1.217,4.825.21.823-5.571,4.81-8.3a26.839,26.839,0,0,1,6.483-3.17c-.081-.388-.131-.613-.131-.613l3.986-2.726-5.9-15.341-15.75-2.428s.142,5.614-.556,8.291",
    transform: "translate(6.023 15.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M74.759,184.3c-.7,2.677-7.579,5.277-7.579,5.277l1.762,3.943S74.579,206.139,77,208.372s5.748,1.217,4.825.21.823-5.571,4.81-8.3a26.839,26.839,0,0,1,6.483-3.17c-.081-.388-.131-.613-.131-.613l3.986-2.726-5.9-15.341-15.75-2.428S75.456,181.619,74.759,184.3Z",
    transform: "translate(6.023 15.78)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M87.058,187.1c.233,1.533-.056,2.848-.645,2.939s-1.257-1.081-1.491-2.614.056-2.848.645-2.938,1.257,1.08,1.491,2.613",
    transform: "translate(7.606 16.54)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M87.232,181.349s-2.317-2.151-4.136-.166-.661,3.641-.661,3.641",
    transform: "translate(7.358 16.168)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M59.722,220.021s-15.154,14.514-17.816,22.421-6.134,76.851-4.732,88.462S40.1,356.715,40.1,356.715s3.906,4.466,13.044,5.154c39.167,2.949,37.148-9.81,37.148-9.81s-.227-81.821-1.53-91.274-12.433-27.694-17.4-32.221a86.118,86.118,0,0,0-11.639-8.543",
    transform: "translate(3.304 19.726)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M59.722,220.021s-15.154,14.514-17.816,22.421-6.134,76.851-4.732,88.462S40.1,356.715,40.1,356.715s3.906,4.466,13.044,5.154c39.167,2.949,37.148-9.81,37.148-9.81s-.227-81.821-1.53-91.274-12.433-27.694-17.4-32.221A86.118,86.118,0,0,0,59.722,220.021Z",
    transform: "translate(3.304 19.726)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M74.592,240.436l8.742,15.645s3.682-4.142,2.3-7.363-11.044-8.282-11.044-8.282",
    transform: "translate(6.687 21.556)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M74.592,240.436l8.742,15.645s3.682-4.142,2.3-7.363S74.592,240.436,74.592,240.436Z",
    transform: "translate(6.687 21.556)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M82.892,254.907l-3.364,71.414,7.28,15.244,4.778-18.657-6.854-69.382Z",
    transform: "translate(7.13 22.73)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M82.892,254.907l-3.364,71.414,7.28,15.244,4.778-18.657-6.854-69.382Z",
    transform: "translate(7.13 22.73)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M54.481,214.285,83.532,239.7l-.895,8.69L51.26,225.346Z",
    transform: "translate(4.596 19.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M54.481,214.285,83.532,239.7l-.895,8.69L51.26,225.346Z",
    transform: "translate(4.596 19.212)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M50.021,303.553l35.84,61.017s5.392,13.638,6.707,14.011,9.141,1.306,9.141,1.306l3.964,1.546s2.649,1.175,3-.571-2.244-15.032-3.559-15.4-10.324-4.279-10.324-4.279L69.709,295.745Z",
    transform: "translate(4.485 26.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M50.021,303.553l35.84,61.017s5.392,13.638,6.707,14.011,9.141,1.306,9.141,1.306l3.964,1.546s2.649,1.175,3-.571-2.244-15.032-3.559-15.4-10.324-4.279-10.324-4.279L69.709,295.745Z",
    transform: "translate(4.485 26.515)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M53.261,239.721S43.184,246.242,42.84,257.5a64.927,64.927,0,0,0,3.216,22.771c.983,2.549-2.27,7.024.5,10.788s5.466,15.315,5.466,15.315l17.552-3.839s-3.4-8.059-1.342-10.317,4.568-4.1,4.328-9.281.384-10.4,1.147-12.594,1.132-31.621-20.444-30.623",
    transform: "translate(3.838 21.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M53.261,239.721S43.184,246.242,42.84,257.5a64.927,64.927,0,0,0,3.216,22.771c.983,2.549-2.27,7.024.5,10.788s5.466,15.315,5.466,15.315l17.552-3.839s-3.4-8.059-1.342-10.317,4.568-4.1,4.328-9.281.384-10.4,1.147-12.594S74.837,238.723,53.261,239.721Z",
    transform: "translate(3.838 21.49)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M47.082,296.9l3.419,8.491,21.4-4.882L69.673,289.8s-18.455,3.016-22.591,7.1",
    transform: "translate(4.221 25.982)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M47.082,296.9l3.419,8.491,21.4-4.882L69.673,289.8S51.217,292.82,47.082,296.9Z",
    transform: "translate(4.221 25.982)",
    fill: "none",
    stroke: "#4e3057",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M154.449,459.522s5.765-18.943,16.472-20.59,28.826.824,29.238,6.177-7.824,13.589-7.824,13.589Z",
    transform: "translate(13.847 39.307)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M154.449,459.522s5.765-18.943,16.472-20.59,28.826.824,29.238,6.177-7.824,13.589-7.824,13.589Z",
    transform: "translate(13.847 39.307)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M193.562,440.834c-8.94.611-16.634,16.845-17.147,17.952l13.951-.3s8.236-8.237,7.825-13.59c-.126-1.634-1.916-3-4.629-4.059",
    transform: "translate(15.816 39.523)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M146.887,436.743s-21.826-4.942-26.767,3.3,16.06,19.354,16.06,19.354h30.061Z",
    transform: "translate(10.702 39.024)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M146.887,436.743s-21.826-4.942-26.767,3.3,16.06,19.354,16.06,19.354h30.061Z",
    transform: "translate(10.702 39.024)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M167.534,459.712S156,432.945,144.885,436.651s10.3,22.65,12.766,22.65Z",
    transform: "translate(12.704 39.116)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 103.362,
    height: 88.538,
    transform: "translate(115.997 498.417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    width: 103.362,
    height: 88.538,
    transform: "translate(115.997 498.417)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    width: 31.297,
    height: 88.538,
    transform: "translate(188.062 498.417)",
    fill: "#4e3057"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 20.59,
    height: 88.538,
    transform: "translate(144 498.417)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 20.59,
    height: 88.538,
    transform: "translate(144 498.417)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M180.148,458.2v43.24l9.059-13.178,7.825,10.707v-41.18Z",
    transform: "translate(16.151 41.042)",
    fill: "#ff6d0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M180.148,458.2v43.24l9.059-13.178,7.825,10.707v-41.18Z",
    transform: "translate(16.151 41.042)",
    fill: "none",
    stroke: "#4e3057",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1017);
export default __webpack_public_path__ + "static/media/Group_1017.635730a29a9101d011f111b5d21c30b9.svg";
export { ForwardRef as ReactComponent };